import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import {BreakpointObserver} from '@angular/cdk/layout';
import { HomeService } from '../service/home.service';
import { formatDataForDropDown } from '../utils/helpers';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from '../service/alert.service';
import { TermsConditionComponent } from '../terms-condition/terms-condition.component';
import * as moment from 'moment';
import { ItemStartdatePopupComponent } from '../item-startdate-popup/item-startdate-popup.component';
import { MatStepper } from '@angular/material/stepper';
import { MatRadioChange } from '@angular/material/radio';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { PlanInfoPopupComponent } from '../plan-info-popup/plan-info-popup.component';
import { translation } from 'src/environments/translation.ar';
import { ItemStartdateArabicPopupComponent } from '../item-startdate-arabic-popup/item-startdate-arabic-popup.component';
import { TranslationService } from '../service/translation.service';

@Component({
  selector: 'app-homepage-arabic',
  templateUrl: './homepage-arabic.component.html',
  styleUrls: ['./homepage-arabic.component.scss']
})
export class HomepageArabicComponent implements OnInit {
  
  carouselOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['&#8249;', '&#8250;'],
    responsive: {
      0: {
        items: 1          // Show 1 card on very small screens (e.g., mobile)
      },
      600: {
        items: 2          // Show 2 cards on small screens (e.g., tablets)
      },
      1000: {
        items: 3          // Show 3 cards on medium screens (e.g., small desktops)
      },
      1200: {
        items: 5          // Show 5 cards on large screens (e.g., large desktops)
      }
    },
    nav: true
  }
  
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  // @ts-ignore
  detailForm: FormGroup;
  personalDetailForm: FormGroup;
  dropDownValues:any = {};
  LocationName:any;
  itemList:any;
  checked:boolean = false;
  itemDetail:any = null;
  TransactionHeadId:any;
  Amount:any;
  minAge: any = 18;
  maxDate;
  minDateError: boolean = false;
  disableSelect: boolean = false;
  forceDisable:boolean = false;
  customerId: any = 1;
  selectedPlan: any = null;
  selectedLegalIdOption:any;
  dayList:any;
  tempDayList:any;
  finalDayList:any;
  dayValue:any;
  monthValue:any;
  yearValue:any;
  isLeapYear:boolean = false;
  startDatePopupValue:any;
  errorMsg:any;
  ShowCardPaymentButton:boolean = false;
  ShowTabbyPaymentButton:boolean = false;
  ShowTamaraPaymentButton:boolean = false;
  minimumAge:any;
  age: number;
  eligible:boolean = false;
  legalIdPlaceholder:any;
  MapUrl:any;
  locationList:any;
  genderList:any = [];
  legalIdTypeIdList:any = [];

 paymentRequestSubmitUrl: string = ""
  translation:any;
  constructor(private translationService: TranslationService,private fb: FormBuilder, private ngxService: NgxUiLoaderService, breakpointObserver: BreakpointObserver,private homeService:HomeService,private alertService:AlertService,private datePipe: DatePipe,private router:Router,private aRoute:ActivatedRoute,public dialog: MatDialog){
    //this.getTranslation();
  }

  ngOnInit():void {
    const translationAll = this.translationService.getAll(); 
    if (translationAll.ar) {
      this.translation = translationAll.ar;
    } 
    else {
      console.warn('Arabic translations not found');
    }

    this.initForm();
    this.initpersonalDetailForm();
    
    this.genderList = []
    this.legalIdTypeIdList = []
    this.genderList = [
    { label: this.translation['Male'], value: 'male' },
    { label: this.translation['Female'], value: 'female' },
  ]
  this.legalIdTypeIdList = [
    { label: this.translation['NationalID'], value: '1' },
    { label: this.translation['ResidentID'], value: '2' },
    { label: this.translation['Passport'], value: '3' }
  ]

    this.getAllCountryDialingCodes();
    this.websiteInitialModel();

    this.getAllCityByGenderForJoinOnline({ value: 'male' } as MatRadioChange);
    this.checkIdentificationTypeValidation({ value: '1' } as MatRadioChange)

    this.maxDate = moment().subtract(Number(this.minAge), 'years');
    this.maxDate = moment(this.maxDate, "YYYY-MM-DD").format("YYYY-MM-DD");
  }
  get form() { return this.detailForm.controls }
  initForm() {
    this.detailForm = this.fb.group({
      Gender:['male'],
      CityId:[null, Validators.required],
      LocationId:[null, Validators.required],
    });
  }

  get personalform() { return this.personalDetailForm.controls }
  initpersonalDetailForm() {
    this.personalDetailForm = this.fb.group({
      Email:[null, Validators.compose([Validators.required, Validators.email])],
      FirstName:[null, Validators.required],
      LastName:[null, Validators.required],
      MobileNo:[null, Validators.required],
      DialingCode:["966"],
      LegalIdTypeId:['1'],
      LegalId:[null, Validators.required],
      DateOfBirth:[null, Validators.required],
      NationalityId:[null, Validators.required],
      HRMSID:[null, this.employeeIdValidator()]
    });
  }

  get hrmsIdControl() {
      return this.personalDetailForm.get('HRMSID');
    }
  
    cleanNumericInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      let value = input.value;
      // Replace any non-digit character with an empty string
      value = value.replace(/[^0-9]/g, '');
      // Update the form control's value directly
      this.hrmsIdControl?.setValue(value, { emitEvent: false }); // Use emitEvent: false to prevent infinite loops with valueChanges
      // Update the input element's value to reflect the clean value immediately
      input.value = value;
    }
  
    employeeIdValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
  
        if (!value) {
          return null; // Let the 'required' validator handle empty values
        }
  
        if (!/^\d+$/.test(value)) {
          return { nonNumeric: true };
        }
  
        if (value.length > 5) {
          return { maxLengthExceeded: true };
        }
  
        if (!value.startsWith('2') && !value.startsWith('3')) {
          return { startsWithInvalidDigit: true };
        }
  
        return null;
      };
    }

  goToHomePage(){
    window.location.href = 'https://in2fitness.sa';
  }

  getAllCountryDialingCodes() {
    this.homeService.getAllCountryDialingCodes({}).subscribe((brands:any) => {
      if (brands['Success']) {
        this.dropDownValues['CountryCodeList'] = formatDataForDropDown(brands['Result'], 'DisplayDialingCode', 'DialingCode');
        console.log(this.dropDownValues)
      }
    })
  }

  websiteInitialModel() {
    this.homeService.websiteInitialModel({}).subscribe((brands:any) => {
      if (brands['Success']) {
        this.minimumAge = brands['Result']['MinAge'];
        this.dayList = brands['Result']['DayList'];
        this.dropDownValues['MonthList'] = formatDataForDropDown(brands['Result']['MonthList'], 'MonthDisplayName', 'MonthId');
        this.dropDownValues['YearList'] = formatDataForDropDown(brands['Result']['YearList'], 'YearName', 'Year');
        this.dropDownValues['CountryList'] = formatDataForDropDown(brands['Result']['CountryList'], 'CountryName', 'CountryId');
      }
    })
  }

  checkLeapYear(){
    console.log(this.yearValue);
    if (this.yearValue % 4 === 0) {
      if (this.yearValue % 100 === 0) {
        if (this.yearValue % 400 === 0) {
          this.isLeapYear = true; // Divisible by 400, it's a leap year
        } else {
          this.isLeapYear = false; // Divisible by 100 but not by 400, not a leap year
        }
      } else {
        this.isLeapYear = true; // Divisible by 4 but not by 100, it's a leap year
      }
    } else {
      this.isLeapYear = false; // Not divisible by 4, not a leap year
    }

    this.validateAge();
    this.getDateList();
  }

  getDateList(){
    console.log(this.monthValue);
    if(this.monthValue == '4' || this.monthValue == '6' || this.monthValue == '9' || this.monthValue == '11'){
      this.tempDayList = this.dayList.slice(0, -1);
    }
    else if(this.monthValue == '2'){
      if(this.isLeapYear){
        console.log(this.dayList.slice(0, -2))
        this.tempDayList = this.dayList.slice(0, -2);
      }
      else{
        console.log(this.dayList.slice(0, -3))
        this.tempDayList = this.dayList.slice(0, -3);
      }
    }
    else{
      this.tempDayList = this.dayList;
    }
    this.finalDayList = this.tempDayList;

    this.validateAge();
  }

  validateAge(){
    this.personalDetailForm.get('DateOfBirth').setValue(null)

    let date = new Date(this.yearValue, this.monthValue - 1, this.dayValue);

    // Extract the year, month, and day
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to month and pad with zero
    let day = date.getDate().toString().padStart(2, '0'); // Pad day with zero

    // Format date as YYYY-MM-DD
    let formattedDate = `${year}-${month}-${day}`;

    console.log(formattedDate); // Output: 2024-08-16

    this.age = this.calculateAge(formattedDate);
    console.log(this.age, this.minimumAge);

    if(this.age >= this.minimumAge){
      this.personalDetailForm.get('DateOfBirth').setValue(formattedDate);
      this.eligible = true;
    }
    else{
      this.eligible = false;
    }
  }

  calculateAge(dob: string): number {
    const birthDate = new Date(dob);
    const currentDate = new Date();

    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthDate.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  getAllCityByGenderForJoinOnline(event: MatRadioChange) {
    this.detailForm.get('CityId').setValue(null);
    this.dropDownValues['LocationList'] = [];
    this.itemList = null;

    console.log(event)
    let gender = event.value;
    this.homeService.getAllCityByGenderForJoinOnline({GenderName: gender}).subscribe((brands:any) => {
      if (brands['Success']) {
        this.dropDownValues['CityList'] = formatDataForDropDown(brands['Result'], 'CityNameLanguage2', 'CityId');
      }
    })
  }

  getAllLocationByCityGenderForJoinOnline(city) {
    this.detailForm.get('LocationId').setValue(null);
    this.dropDownValues['LocationList'] = [];
    this.itemList = null;

    let gender = this.detailForm.get('Gender').value;
    let location = {
      GenderName: gender,
      CityId: city['value']
    }
    this.homeService.getAllLocationByCityGenderForJoinOnline(location).subscribe((brands:any) => {
      if (brands['Success']) {
        this.locationList = brands['Result'];
        this.dropDownValues['LocationList'] = formatDataForDropDown(brands['Result'], 'LocationNameLanguage2', 'LocationId');
      }
    })
  }

  itemListWithoutCustomer(){
    this.itemList = null;
    
    let location = this.detailForm.get('LocationId').value;

    for(let i=0; i < this.locationList.length; i++){
      if(location == this.locationList[i]['LocationId']){
        this.MapUrl = this.locationList[i]['MapUrl'];
      }
    }
    
    let item = {
      CustomerId: this.customerId,
      LocationId: location
    }
    this.homeService.ItemListWithoutCustomer(item).subscribe((brands:any) => {
      if (brands['Success']) {
        this.itemList = brands['Result']['ItemList'];
        
        this.TransactionHeadId = brands['Result']['TransactionHeadId']
      }
    })
  }

  selectPlan(item){
    console.log(item)
    let date1;
    let date2;

    if (item['MinStartDate']) {
      date1 = new Date(moment(item['MinStartDate'], "YYYY-MM-DD").format("YYYY-MM-DD"));
    }

    if (item['MaxStartDate']) {
      date2 = new Date(moment(item['MaxStartDate'], "YYYY-MM-DD").format("YYYY-MM-DD"))
    }

    if (date1.getTime() === date2.getTime()) {
      this.startDatePopupValue = item['MinStartDate'];
      this.selectedPlan = item;
    }
    else{
      const dialogRef = this.dialog.open(ItemStartdateArabicPopupComponent,{
        width: '30rem',
        height: '24rem',
        data: {rowData: item}
      });
      dialogRef.afterClosed().subscribe((fromPopup)=>{
        if(fromPopup){
          console.log(fromPopup)
          this.startDatePopupValue = fromPopup['ItemStartDate'];
          console.log(item)
          this.selectedPlan = item;
        }
      })
    }
  }

  isSelected(item: any): boolean {
    return this.selectedPlan === item;  // Check if the item is selected
  }

  addTransactionItem(){
    let transactionData = {
      TransactionHeadId: this.TransactionHeadId,
      ItemId: this.selectedPlan['ItemId'],
      ItemStartDate: this.startDatePopupValue,
      ItemClassificationName: this.selectedPlan['ItemClassificationName'],
      ItemDescription: this.selectedPlan['ItemDescription'],
      Price: this.selectedPlan['Price']
    }
    this.homeService.AddTransactionItem(transactionData).subscribe((brands:any) => {
      if (brands['Success']) {
        this.stepper.next();
      }
    });
  }

  onEmailInput(event: any): void {
    const lowerCaseValue = event.target.value.toLowerCase();
    this.personalDetailForm.get('Email').setValue(lowerCaseValue, { emitEvent: false });
  }

  checkIdentificationTypeValidation(event: MatRadioChange){
    console.log(event.value);
    let nationalId = this.personalDetailForm.get('LegalId');
    this.selectedLegalIdOption = event.value;
    if(event.value == 1){
      this.legalIdPlaceholder = 'e.g. 1xxxxxxxxx';
      nationalId.setValidators([Validators.required, Validators.pattern(/^1\d{9}$/)]);
    }
    else if(event.value == 2){
      this.legalIdPlaceholder = 'e.g. 2xxxxxxxxx';
      nationalId.setValidators([Validators.required, Validators.pattern(/^2\d{9}$/)]);
    }
    else{
      this.legalIdPlaceholder = '';
      nationalId.setValidators(null)
    }

    nationalId.updateValueAndValidity();
  }

  checkInputNumber(event: any){
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, ''); 
  }

  goToTerms(){
    console.log(this.checked)
    const dialogRef = this.dialog.open(TermsConditionComponent,{
      width: '80vw',
      height: '80vh',
      data: {
        transId: this.TransactionHeadId
      }
    });
    dialogRef.afterClosed().subscribe((fromPopup)=>{
      if(fromPopup){

      }
    });
  }

  addMemberFromJoinOnlineWebsite(){
    let transactionData = {
      TransactionHeadId: this.TransactionHeadId,
      CityId: this.detailForm.get('CityId').value,
      FirstName: this.personalDetailForm.get('FirstName').value,
      LastName: this.personalDetailForm.get('LastName').value,
      Gender: this.detailForm.get('Gender').value,
      Email: this.personalDetailForm.get('Email').value,
      CountryCode: this.personalDetailForm.get('DialingCode').value,
      MobileNo: this.personalDetailForm.get('MobileNo').value,
      DateOfBirth: this.personalDetailForm.get('DateOfBirth').value,
      DialingCode: this.personalDetailForm.get('DialingCode').value,
      LocationId: this.detailForm.get('LocationId').value,
      LegalId: this.personalDetailForm.get('LegalId').value,
      LegalIdTypeId: this.personalDetailForm.get('LegalIdTypeId').value,
      NationalityId: this.personalDetailForm.get('NationalityId').value,
      HRMSID: this.personalDetailForm.get('HRMSID').value,
      WebisteLanguage: 'ar'
    }
    this.homeService.AddMemberFromJoinOnlineWebsite(transactionData).subscribe((brands:any) => {
      if (brands['Success']) {
        this.paymentOption();
        this.stepper.next();
      }
      else{
        this.errorMsg = brands['Message'];
      }
    });
  }
  
  paymentOption(){
    let transactionData = {
      TransactionHeadId: this.TransactionHeadId,
      ItemId: this.selectedPlan['ItemId'],
      Price: this.selectedPlan['Price'],
      ItemName: this.selectedPlan['ItemDescription']
    }
    this.homeService.PaymentOption(transactionData).subscribe((brands:any) => {
      if (brands['Success']) {
        this.ShowCardPaymentButton = brands['Result']['ShowCardPaymentButton'];
        this.ShowTabbyPaymentButton = brands['Result']['ShowTabbyPaymentButton']
        this.ShowTamaraPaymentButton = brands['Result']['ShowTamaraPaymentButton']
      }
      else{
       
      }
    });
  }
  
  selectPaymentMode(mode){
    let transactionData = {
      TransactionHeadId: this.TransactionHeadId,
      PaymentType: mode,
      FromApplication: "Website"
    }
    this.homeService.PaymentNow(transactionData).subscribe((brands:any) => {
      if (brands['Success']) {
        this.paymentRequestSubmitUrl = brands['Result'];//['PaymentRequestSubmitUrl'];
        if (this.paymentRequestSubmitUrl != "") {
          window.location.href = this.paymentRequestSubmitUrl;
        }
      }
      else{
       
      }
    });
  }

  showDescription(item){
    
      const dialogRef = this.dialog.open(PlanInfoPopupComponent,{
        width:'25rem',
        disableClose: true,
        panelClass: 'custom-dialog-container',
        data: {itemData: item}
      });
      dialogRef.afterClosed().subscribe((fromPopup)=>{
        if(fromPopup){
  
        }
      });
    
  }

  getDirections(){
    const url = this.MapUrl
    window.open(url.toString(), '_blank')
  }

  goToEnglishPage(){
    this.router.navigate(['/', 'home']);
  }

  goToArabicPage(){
    this.router.navigate(['/', 'home-ar']);
  }

  allowOnlyEnglish(event: KeyboardEvent) {
  const allowedPattern = /^[a-zA-Z0-9\s.,?!@#]$/;

  const key = event.key;

  // Allow navigation keys like Backspace, Tab, Arrow keys, etc.
  if (
    key === 'Backspace' ||
    key === 'Tab' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Delete'
  ) {
    return;
  }

  if (!allowedPattern.test(key)) {
    event.preventDefault();
  }
}

blockNonEnglishPaste(event: ClipboardEvent) {
  const pasteData = event.clipboardData?.getData('text') || '';
  const allowed = /^[a-zA-Z0-9\s.,?!@#]*$/;

  if (!allowed.test(pasteData)) {
    event.preventDefault();
  }
}
}

